/* 
 * 21.02.2018
 * NewCatController ile birlikte CategoryAndFilters.js yerine kullanılır
 * Infinity Scroll yerine Paging yapısına uygundur
 * $(document).ready 'nin üstünde bulunan fonksiyonlar açılışta çağrılır
 * $(document).ready 'nin altında bulunan fonksiyonlar event'lara bağlıdır, $(document).ready 'deki click olaylarıyla tetiklenir
 */

var date = new Date();
date.setTime(date.getTime() + (5 * 60 * 1000));

function ToggleLeftBar() {
    if ($(window).width() > 991) {
        $(".FilterForm .filterLink, .SubCatNavs .filterLink").live("click", function () {
            $(this).toggleClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").slideToggle();
        });
    }
    else {
        $(".FilterForm .filterLink").live("click", function () {
            if ($(this).hasClass("toggle-minus")) {
                $(this).removeClass("toggle-minus");
                $(this).parent().find(".FilterBoxes").removeClass("active");
            }
            else {
                $(this).addClass("toggle-minus");
                $(this).parent().find(".FilterBoxes").addClass("active");
            }
        });
    }
}

function SetSlider() {
    if ($(".CategoryLeftBar").length > 0 && $("#PgType").val() == "Cat" || $("#PgType").val() == "NewSearch") {
        var slider = document.getElementById('PriceSlider');
        var min = $("#MinPrice").val();
        var max = $("#MaxPrice").val();
        var currencySymbol = $("#CurrencySymbol").val();

        noUiSlider.create(slider, {
            start: [min, max],
            connect: true,
            step: 1,
            range: {
                'min': parseInt(min),
                'max': parseInt(max)
            }
        });

        slider.noUiSlider.on('change', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $("#SliderValue").val(Math.round(values[0]) + "-" + Math.round(values[1]));

            if ($(window).width() > 991) {
                GetPageByFilter();
            }
        });

        slider.noUiSlider.on('update', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $(".priceView").html("").html(Math.round(values[0]) + " " + currencySymbol + "<span style='padding: 0px 40px;'></span> " + Math.round(values[1]) + " " + currencySymbol);
        });
    }

    if ($("#grid-slider").length > 0) {
        var gridSlider = document.getElementById("grid-slider");

        noUiSlider.create(gridSlider, {
            start: 3,
            connect: true,
            step: 1,
            range: {
                'min': 3,
                'max': 5
            }
        });

        gridSlider.noUiSlider.on('change', function () {
            var values = gridSlider.noUiSlider.get();
            $("#GridValue").val(values[0]);

            SetGridByCookie(values[0]);
        });
    }
}

function LazyLoad() {
    $(".ProductList .Prd img.PImage.FirstImage, .ProductList .Prd .ProductListColor img").Lazy();
}

// Cookie Değerine Göre Açılış Grid'ini Ayarlama Fonksiyonu
function SetGridByCookie(GridSize) {
    var cookieGrid = $.cookie("BSLgridCookie");

    if (!cookieGrid)
        cookieGrid = "4";

    if (GridSize)
        cookieGrid = GridSize;

    $.cookie("BSLgridCookie", cookieGrid, { path: '/' });
    $(".ProductList").attr("data-grid-size", cookieGrid);

    var gridSlider = document.getElementById("grid-slider");
    if (gridSlider)
        gridSlider.noUiSlider.set(cookieGrid);
}

// Açılışta QueryString'deki Filtreleme Seçeneklerini Kontrol Eder
function QueryStringControlForFilter() {

    var vars = [], hash;
    var selectedSize = "";
    var selectedColor = "";
    var selectedPrice = "";
    var selectedSoldOut = "";
    var selectedSort = "";
    var selectedPropertie = "";
    var selectedCloth = "";
    var selectedPage = "";
    var haveFilter = false;
    var selectedCatalog = "";
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "s") {
                selectedSize = hash[1]; // Size değerleri alınır
                haveFilter = true;
            }
            else if (hash[0] == "c") {
                selectedColor = hash[1]; // Color değerleri alınır
                haveFilter = true;
            }
            else if (hash[0] == "prc") {
                selectedPrice = hash[1]; // Price değerini alınır
                haveFilter = true;
            }
            else if (hash[0] == "so") {
                selectedSoldOut = hash[1]; // Tükenenleri Gizle seçeneğini alır
                haveFilter = true;
            }
            else if (hash[0] == "o") {
                selectedSort = hash[1]; // Sıralama seçeneği alınır
                haveFilter = true;
            }
            else if (hash[0] == "prp") {
                selectedPropertie = hash[1];
                haveFilter = true;
            }
            else if (hash[0] == "clh") {
                selectedCloth = hash[1];
                haveFilter = true;
            }
            else if (hash[0] == "ct") {
                selectedCatalog = hash[1];
                haveFilter = true;
            }
            else if (hash[0] == "p" && IsSearch) {
                selectedPage = hash[1]; // Sıralama seçeneği alınır
                if (selectedPage > 1) {
                    haveFilter = true;
                }
            }
        }

        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSize != null && selectedSize != "" && selectedSize != undefined) {
            var selectedSizes = selectedSize.split(',');

            $.each(selectedSizes, function (key, value) {
                $li = $("#Sizes li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedColor != null && selectedColor != "" && selectedColor != undefined) {
            var selectedColors = selectedColor.split(',');

            $.each(selectedColors, function (key, value) {
                $li = $("#Colors li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedPropertie != null && selectedPropertie != "" && selectedPropertie != undefined) {
            var selectedProperties = selectedPropertie.split(',');

            $.each(selectedProperties, function (key, value) {
                $li = $("#Properties li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Kumaşların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCloth != null && selectedCloth != "" && selectedCloth != undefined) {
            var selectedCloths = selectedCloth.split(',');

            $.each(selectedCloths, function (key, value) {
                $li = $("#Cloth li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Özelliklerin li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili katalogların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCatalog != null && selectedCatalog != "" && selectedCatalog != undefined) {
            var selectedCatalogs = selectedCatalog.split(',');

            $.each(selectedCatalogs, function (key, value) {
                $li = $("#ProductGroup li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili katalogların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Price değer aralığını ayarlar
        if (selectedPrice != null && selectedPrice != "" && selectedPrice != undefined) {

            $("#SliderValue").val(selectedPrice);
            var SelectedPrices = selectedPrice.split('-');

            var slider = document.getElementById('PriceSlider');
            slider.noUiSlider.set([SelectedPrices[0], SelectedPrices[1]]);
        }
        // Seçili Price değer aralığını ayarlar

        // Seçiliyse tükenenleri gizle seçeneğini işaretler
        if (selectedSoldOut != null && selectedSoldOut != "" && selectedSoldOut != undefined && selectedSoldOut == "1") {
            $li = $("#SoldOutOp li.gr");
            $li.find("input").attr("checked", "checked");
            $li.find("input").val("1");
            $li.find("label").addClass("checked2");
        }
        // Seçiliyse tükenenleri gizle seçeneğini işaretler

        // Sıralama varsa dropdown'dan seçeneği işaretler
        if (selectedSort != null && selectedSort != "" && selectedSort != undefined) {

            $li = $("#PrdSort input[value='" + selectedSort + "']").parent("li");

            $li.find("label").addClass("checked");
            $li.find("label").addClass("c_on");

            //$(".fLinkSortNo").html($li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir
        }
        // Sıralama varsa dropdown'dan seçeneği işaretler

        if (IsSearch() && haveFilter) {
            getPageByPageNo(selectedPage);
        }
    }

    GetSelectedFilter(); // Gelen filtreleri Seçili Filtreler alanına ekler
}

function IsSearch() {
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (NativeQueryFilter.indexOf("sr=") != "-1") {
        return true;
    }
    else {
        return false;
    }
}

// Seçimleriniz alanını footer'da gizler
function HideChoices() {

    $(window).scroll(function (event) {
        var y = $(this).scrollTop();
        var height = 0;

        $(".FilterForm .col-md-24").not(".AppylArea").each(function () {
            height += $(this).height();
        });

        height = height - 700;

        if (y >= height) {
            $(".AppylArea").removeClass("AppylAreaFixed");

        } else {
            $(".AppylArea").addClass("AppylAreaFixed");
        }
    });

}

// Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
function BackButtonLastScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var browserName = navigator.userAgent;
    if (browserName.indexOf("Chrome")) {
        browserName = "Chrome";
    }

    var pgType = $("#PgType").val();
    var lastScrollTop = $.cookie("lastScroll");
    var CatID = $("#PID").val();
    var lastScrollTopFirst = $.cookie("getLastScrollFirst");

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (pgType == "Cat" || pgType == "NewSearch") {

        if (CatID != $.cookie("lastCatalogID")) {
            lastScrollTopFirst = 0;
            $.cookie("lastCatalogID", CatID, { path: '/', expires: date });
        }

        if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
            if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {

                var listHeight = $(".ProductList").height();
                lastScrollTop = lastScrollTop - (listHeight /** (currentPage - 1)*/);

                if (lastScrollTop > 0) {
                    $('html, body').animate({
                        scrollTop: lastScrollTop
                    }, 0);
                }
            }
        }

        //if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
        //    if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTop
        //            }, 0);
        //        }, 1000);
        //    }
        //}
        //else {

        //    if (lastScrollTopFirst != null && lastScrollTopFirst != "" && lastScrollTopFirst != undefined && lastScrollTopFirst > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTopFirst
        //            }, 0);
        //        }, 1000);
        //    }
        //}

        $.cookie("getLastScrollFirst", "0", { path: '/', expires: date });
        $.cookie("lastScroll", "0", { path: '/', expires: date });
    }
}

function getPenPath() {
    var vars = [], hash;
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder
    var currentPage = 1;

    if (NativeQueryFilter.indexOf("=") != "-1") {
        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                currentPage = hash[1];
            }
        }
    }

    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var params = "";

    if (ios == true) {
        params = GenerateParams("paging", this.loadCount + 2 /*this.loadCount + 2*/); // Sayfalama için istek parametresi üretir
    }
    else {
        params = GenerateParams("paging", (parseInt(currentPage) + 1) /*this.loadCount + 2*/); // Sayfalama için istek parametresi üretir
    }

    if (params) {
        //return "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList?" + params;
        return "?" + params;
    }
}

//ürünleri dörder dörder datalayere initify scroll ile gönderir
//ilk 4 ürünü sayfa yüklenir yüklenmez gönderir
function ScrollFourGetProduct() {

    var productList = $('.contentTopSpace .ProductColumn .PrdContainer .Products .ProductList');

    var products = productList.find('.PrdItemBox');

    var currentUrl = window.location.pathname;

    var catalogList = currentUrl.split('/');

    var catalogNameList = [];

    for (var i = 2; i < catalogList.length; i++) {

        if (catalogList[i] != null && catalogList[i] != undefined && catalogList[i].length > 0) {

            catalogNameList.push(catalogList[i]);

        }
    }

    if (catalogNameList != null && catalogNameList != undefined && catalogNameList.length > 0) {

        var catName1 = null;
        var catName2 = null;
        var catName3 = null;

        for (var i = 0; i < catalogNameList.length; i++) {
            if (i == 0 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                catName1 = catalogNameList[i];
            }
            else if (i == 1 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                catName2 = catalogNameList[i];
            }
            else if (i == 2 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                catName3 = catalogNameList[i];
            }
        }

        var UserID = $('#UserID').val();

        if (!UserID || UserID == "0")
            UserID = "unknown";

        var productListFirst = []; // Boş bir dizi oluştur
        var productChunkFirst = products.slice(0, 4);

        productChunkFirst.each(function (index, element) {

            if (!$(element).hasClass('datalayerpush')) {
                $(element).addClass('datalayerpush');

                var temp = $(this).find('.button-container .AddToCart');

                console.log('temp: ', temp);
                console.log('data-quantity: ', temp.attr('data-quantity'));

                var ProductURL = temp.attr('data-producturl');
                var dataProductName = temp.attr('data-productname');
                var dataProductId = temp.attr('data-productid');
                var dataProductQuantity = temp.attr('data-quantity');
                var dataProductAmount = temp.attr('data-productamount') != undefined ? temp.attr('data-productamount').replace(',', '.') : undefined;
                var dataProductColorName = temp.attr('data-colorname');
                var dataProductListPosition = temp.attr('data-listposition');
                var dataProductDiscountRate = temp.attr('data-discountRate');
                var dataProductCatalogId = temp.attr('data-CatalogId');

                var dataProductCode = temp.attr('data-productcode');
                var dataColorCode = temp.attr('data-ColorCode');

                var AddToCartId = dataProductCode + "-R" + dataColorCode;

                var PrivateCatName3 = catName3;
                if (PrivateCatName3 == null) {
                    PrivateCatName3 = catName2;
                }
                if (catName2 == null && PrivateCatName3 == null) {
                    PrivateCatName3 = catName1;
                }
                if (catName2 == null && PrivateCatName3 == null && catName1 == null) {
                    PrivateCatName3 = null;
                }

                var viewItemFirst = {
                    item_id: AddToCartId, //Type: String
                    item_group_id: dataProductCode, //Type: String
                    item_name: dataProductName, //Type: String
                    currency: "TRY", //Type: String
                    discount: parseFloat(dataProductDiscountRate), //Type: Float
                    index: parseInt(dataProductListPosition), //Type: Integer, Desciption: Position in the list
                    item_brand: "BSL", //Type: String
                    item_category: catName1, //Type: String, Description: Main category of the product
                    item_category2: catName2, //Type: String, Description: Type of the product
                    item_list_id: dataProductCatalogId, //Type: String
                    item_list_name: PrivateCatName3, //Type: String
                    item_variant: null, //Type: String, Description: Size
                    item_size: null, //Type: String
                    item_color: dataProductColorName, //Type: String
                    price: parseFloat(dataProductAmount), //Type: Float
                    quantity: 1, //parseInt(dataProductQuantity) //Type: Integer
                    stock: parseInt(dataProductQuantity)
                };

                productListFirst.push(viewItemFirst);

                if (productListFirst.length == 4) {

                    // push
                    dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                    dataLayer.push({
                        event: "ecom_event",
                        event_category: "ecommerce",
                        event_action: "view_item_list",
                        ecommerce: {
                            items: [productListFirst]
                        }
                    });

                    // Listeyi sıfırla
                    productListFirst = [];
                }
            }
        });

        var scrolled_val = 0;
        var viewItemList = [];

        $(window).scroll(function () {

            scrolled_val = $(document).scrollTop().valueOf();

            scrolled_val = parseInt(scrolled_val);

            var i = 0;
            var j = 4;
            var length = products.length;

            while (i < length) {

                var productChunk = products.slice(i, j);

                productChunk.each(function (index, element) {

                    var position = $(element).offset();

                    position = parseInt(position.top);

                    if (scrolled_val > position - 200) {

                        if (!$(element).hasClass('datalayerpush')) {
                            $(element).addClass('datalayerpush');

                            var temp = $(this).find('.button-container .AddToCart');
                            var ProductURL = temp.attr('data-producturl');
                            var dataProductName = temp.attr('data-productname');
                            var dataProductId = temp.attr('data-productid');
                            var dataProductQuantity = temp.attr('data-quantity');
                            var dataProductAmount = temp.attr('data-productamount') != undefined ? temp.attr('data-productamount').replace(',', '.') : undefined;
                            var dataProductColorName = temp.attr('data-colorname');
                            var dataProductListPosition = temp.attr('data-listposition');
                            var dataProductDiscountRate = temp.attr('data-discountRate');
                            var dataProductCatalogId = temp.attr('data-CatalogId');

                            var dataProductCode = temp.attr('data-productcode');
                            var dataColorCode = temp.attr('data-ColorCode');

                            var AddToCartId = dataProductCode + "-R" + dataColorCode;

                            var PrivateCatName3n = catName3;
                            if (PrivateCatName3n == null) {
                                PrivateCatName3n = catName2;
                            }
                            if (catName2 == null && PrivateCatName3n == null) {
                                PrivateCatName3n = catName1;
                            }
                            if (catName2 == null && PrivateCatName3n == null && catName1 == null) {
                                PrivateCatName3n = null;
                            }

                            var viewItem = {
                                item_id: AddToCartId, //Type: String
                                item_group_id: dataProductCode, //Type: String
                                item_name: dataProductName, //Type: String
                                currency: "TRY", //Type: String
                                discount: parseFloat(dataProductDiscountRate), //Type: Float
                                index: parseInt(dataProductListPosition), //Type: Integer, Desciption: Position in the list
                                item_brand: "BSL", //Type: String
                                item_category: catName1, //Type: String, Description: Main category of the product
                                item_category2: catName2, //Type: String, Description: Type of the product
                                item_list_id: dataProductCatalogId, //Type: String
                                item_list_name: PrivateCatName3n, //Type: String
                                item_variant: null, //Type: String, Description: Size
                                item_size: null, //Type: String
                                item_color: dataProductColorName, //Type: String
                                price: parseFloat(dataProductAmount), //Type: Float
                                quantity: 1, //parseInt(dataProductQuantity) //Type: Integer
                                stock: parseInt(dataProductQuantity)
                            };

                            // Listeye ekle
                            viewItemList.push(viewItem);

                            if (viewItemList.length == 4) {

                                // push
                                dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                                dataLayer.push({
                                    event: "ecom_event",
                                    event_category: "ecommerce",
                                    event_action: "view_item_list",
                                    ecommerce: {
                                        items: [viewItemList]
                                    }
                                });

                                // Listeyi sıfırla
                                viewItemList = [];
                            }
                        }
                    }
                });
                i = j;
                j += 4;
            }

        });

    }
}

//ürün listesinde ürüne tıklandığı anda datalayere push yapacak script
function ProductListSelectDetailClick() {

    var productList = $('.contentTopSpace .ProductColumn .PrdContainer .Products .ProductList');

    var products = productList.find('.PrdImgsBox .carousel');

    var currentUrl = window.location.pathname;

    var catalogList = currentUrl.split('/');

    var catalogNameList = [];

    for (var i = 2; i < catalogList.length; i++) {

        if (catalogList[i] != null && catalogList[i] != undefined && catalogList[i].length > 0) {

            catalogNameList.push(catalogList[i]);

        }
    }

    if (catalogNameList != null && catalogNameList != undefined && catalogNameList.length > 0) {

        var catName1 = null;
        var catName2 = null;
        var catName3 = null;

        for (var i = 0; i < catalogNameList.length; i++) {
            if (i == 0 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                catName1 = catalogNameList[i];
            }
            else if (i == 1 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                catName2 = catalogNameList[i];
            }
            else if (i == 2 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                catName3 = catalogNameList[i];
            }
        }

        products.click(function () {

            var UserID = $('#UserID').val();

            if (!UserID || UserID == "0")
                UserID = "unknown";

            var dataProductId = $(this).attr('data-productid');

            var dataProductName = $(this).attr('data-productname');
            var dataProductDiscount = $(this).attr('data-productdiscount').replace(',', '.');
            var dataProductListPosition = $(this).attr('data-listposition') - 1;
            var dataProductCatalogId = $(this).attr('data-catalogId');

            var dataProductCalatalogName = $(this).attr('data-catalogname');

            var dataProductColorName = $(this).attr('data-colorname');
            var dataProductAmount = $(this).attr('data-productamount').replace(',', '.');

            var dataProductQuantity = $(this).attr('data-productquantity');

            var dataProductCode = $(this).attr('data-productcode');
            var dataColorCode = $(this).attr('data-colorcode');

            var AddToCartId = dataProductCode + "-R" + dataColorCode;

            var PrivateCatName3 = catName3;
            if (PrivateCatName3 == null) {
                PrivateCatName3 = catName2;
            }
            if (catName2 == null && PrivateCatName3 == null) {
                PrivateCatName3 = catName1;
            }
            if (catName2 == null && PrivateCatName3 == null && catName1 == null) {
                PrivateCatName3 = null;
            }

            dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
            dataLayer.push({
                event: "ecom_event",
                event_category: "ecommerce",
                event_action: "select_item",
                ecommerce: {
                    items: [{
                        item_id: AddToCartId, //Type: String
                        item_group_id: dataProductCode, //Type: String
                        item_name: dataProductName, //Type: String
                        currency: "TRY", //Type: String
                        discount: parseFloat(dataProductDiscount), //Type: Float
                        index: parseInt(dataProductListPosition), //Type: Integer, Desciption: Position in the list
                        item_brand: "BSL", //Type: String
                        item_category: catName1, //Type: String, Description: Main category of the product
                        item_category2: catName2, //Type: String, Description: Type of the product
                        item_category3: catName3, //Type: String, Description: Type of the product
                        item_list_id: dataProductCatalogId, //Type: String
                        item_list_name: PrivateCatName3, //Type: String
                        item_variant: null, //Type: String, Description: Size
                        item_size: null, //Type: String
                        item_color: dataProductColorName, //Type: String
                        price: parseFloat(dataProductAmount), //Type: Float
                        quantity: 1, //Type: Integer
                        stock: parseInt(dataProductQuantity)
                    }]
                }
            });

        });

    }

}

function InfinityScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var history = 'push';

    if (ios == true) {
        history = false;
    }

    $container = $('.ProductList').infiniteScroll({
        path: getPenPath,
        append: '.Prd',
        scrollThreshold: 100,
        checkLastPage: ".pageEnd",
        history: history
    });

    var infScroll = $container.data('infiniteScroll');

    $container.on('load.infiniteScroll', function () {
        setTimeout(function () {
            LazyLoad();
            SetGridByCookie();
            StartProductVideoFoProductList();
        }, 1000);
    });
}

function NewcatSlick() {
    var element = $(".js-cat-product-group");

    if (element.length == 0 && element.children("li").length <= 0) {
        $(".SubCats").css("display", "none");
        $(".mobileCollectionicon").css("display", "none");
        $(".MobilBreadCrumbArea").css("justify-content", "center");
        /*$(".MobilBreadCrumbArea .BreadActive").css("text-transform", "uppercase");*/
        $(".MobilBreadCrumbArea").css("margin-left", "0");
        return false;
    }

    if ($(window).width() <= 991) {
        return false;
    }

    else {
        element.on('init', function (event, slick, direction) {
            element.find("li a").addClass("show");
        });

        element.slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right-arrow'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left-arrow'></i></div>",
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true
        });
    }
}

$(window).on('load', function () {
    StartProductVideoFoProductList();
});

$(document).ready(function () {
    ScrollFourGetProduct();
    ProductListSelectDetailClick();
    NewcatSlick();

    var PageType = $("#PgType").val();

    if (PageType == "Cat" || PageType == "Combine" || PageType == "NewSearch") {

        var InfinityScroll = $("#IsInfinity").val();

        if (InfinityScroll == "True") {
            var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            var history = 'push';

            if (ios == true) {
                history = false;
            }
            else {
                scrollFrame('.ProductList .Prd .PrdImgsBox .carousel-item > a, .ProductList .Prd .PrdItemBox .product-info > a');
            }

            $container = $('.ProductList').infiniteScroll({
                path: getPenPath,
                append: '.Prd',
                scrollThreshold: 100,
                checkLastPage: ".pageEnd",
                history: history
            });

            var infScroll = $container.data('infiniteScroll');

            $container.on('load.infiniteScroll', function () {
                setTimeout(function () {
                    LazyLoad();
                    SetGridByCookie();
                    StartProductVideoFoProductList();
                }, 1000);
            });
        }
        else {
            BackButtonLastScroll(); // Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
        }

        // Filter Bar Window

        if ($(window).width() > 991) {
            $(document).on("click", "#filterButton", function () {
                $(".CategoryLeftBar").toggleClass("open");
            });
        }

        else if ($(window).width() < 991) {
            $(document).on("click", "#filterButton", function () {
                $(".CategoryLeftBar").toggleClass("open");
                $("body").toggleClass("overflow-hidden")
            });
        }

        if (PageType == "NewSearch") {
            $(".MobilBreadCrumbArea").css("display", "none");
        }

        // Left/Filter Bar
        ToggleLeftBar();
        SetSlider();
        LazyLoad(); // Lazy Load    
        SetGridByCookie(); // Cookie Değerine Göre Grid Ayarlama
        ClearAllFilter("false");
        QueryStringControlForFilter(); // QueryString'deki filtreleri kontrol eder
        IsFollowCategory(); // Favorilerin kontrolü

        if ($(window).width() > 991) {
            HideChoices(); // Seçimleriniz alanını footer'da gizler(Sadece Desktop)
            $(".CatBannerContainerMobile").remove();

            $(document).on("click", "#LeftWrapper .FilterBoxes li > label, #SubCatNavs .FilterBoxes li > label", function () {
                GetPageByFilter();
            });
        }
        else {
            $(".CatBannerContainer").remove();
        }

        //BrowserBackAndPrevButtonControl(); // Browser iler/geri tuşları tetiklenince çalışır

        if ($(window).width() < 992) {
            // Backdrop tıklanınca filtre&sıralama alanı kapatılsın
            $(document).on("click", ".backdrop", function () {
                $(".MobilSortArea").slideUp("normal");
                $(".mobilFilterArea").removeClass("open");
                $(".backdrop").removeClass("openFilter").removeClass("rightMenu");
            });

            $(document).on("click", "#LeftWrapper .FilterArea .mobilFilterArea .MobilFilterHeader .headertitle i", function () {
                $(".MobilSortArea").slideUp("normal");
                $(".mobilFilterArea").removeClass("open");
                $(".backdrop").removeClass("openFilter").removeClass("rightMenu");
            });

            // Mobil filtre geri kaydırma
            $(document).on("click", ".FilterForm .FilterBoxes .MobileFilterHeader a", function () {
                $(this).parents(".FilterOption").removeClass("active");
                $(this).parents(".col-md-24").children(".filterLink").addClass("toggle-minus");
            });

            $(document).on("click", ".FilterApplyButton", function () {
                $(".CategoryLeftBar").removeClass("open");
                $("body").toggleClass("overflow-hidden");
            });
        }

        $(document).on("click", ".FilterApplyButton", function () {
            $(".CategoryLeftBar").removeClass("open");
        });
    }

    // Ürünler
    $(document).on("click", ".ProductList .Prd .AddToCartArea button.AddToCart", function () {

        $basketButton = $(this);

        var thisPrd = $(this).closest(".Prd");
        var SizeID = $basketButton.attr("data-sizeid");
        var ColorID = $basketButton.attr("data-colorid");
        var ProductID = $basketButton.attr("data-productid");
        var ProductCode = $basketButton.attr("data-productcode");
        var ColorCode = $basketButton.attr("data-colorcode");
        var ProductName = $basketButton.attr("data-productname");
        var ColorName = $basketButton.attr("data-colorname");
        var TotalQuantity = $basketButton.attr("data-quantity");
        var ProductPathURL = $basketButton.attr('data-producturl');
        var ListPosition = $basketButton.attr("data-listposition");
        var CatID = $basketButton.attr('data-catalogid');

        var ProductAmount = $basketButton.attr("data-productamount");

        if (ProductAmount != undefined && ProductAmount != null && ProductAmount != "0") {
            ProductAmount = $basketButton.attr("data-productamount").replace(',', '.');
        }
        else {
            ProductAmount = 0;
        }

        var discountRate = $basketButton.attr('data-discountrate');

        if (discountRate != undefined && discountRate != null && discountRate != "0") {
            discountRate = $basketButton.attr('data-discountrate').replace(',', '.');
        }
        else {
            discountRate = 0;
        }

        var pl = $('.ProductList');
        var UserMail = pl.attr('data-useremail');
        var UserPhone = pl.attr('data-gsm');
        var UserHashedMail = pl.attr('data-hashedEmail');
        var UserHashedGSM = pl.attr('data-hashedGSM');
        var UserGender = pl.attr('data-gender');

        var location1 = window.location.href;

        var currentUrl = window.location.pathname;

        var catalogList = currentUrl.split('/');

        var catalogNameList = [];

        for (var i = 2; i < catalogList.length; i++) {

            if (catalogList[i] != null && catalogList[i] != undefined && catalogList[i].length > 0) {

                catalogNameList.push(catalogList[i]);

            }
        }

        var LangID = $("#SmallLangCode").val();
        var UserID = $('#UserID').val();

        if (!UserID || UserID == "0")
            UserID = "unknown";

        if (!$basketButton.hasClass("passive")) {
            if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "" && SizeID != "0" && ColorID != "0" && ProductID != "0") {

                var AddToCartId = ProductCode + "-R" + ColorCode;

                //alert(AddToCartId);

                var param = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + 1 + "&langID=" + LangID;

                GenerateLocalLoading($basketButton.parents(".Prd"), "show");
                AddToCard(param, function (dt) {

                    if (dt.Sonuc == true) {

                        if (catalogNameList != null && catalogNameList != undefined && catalogNameList.length > 0) {

                            var catName1 = null;
                            var catName2 = null;
                            var catName3 = null;

                            for (var i = 0; i < catalogNameList.length; i++) {
                                if (i == 0 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                    catName1 = catalogNameList[i];
                                }
                                else if (i == 1 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                    catName2 = catalogNameList[i];
                                }
                                else if (i == 2 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                    catName3 = catalogNameList[i];
                                }
                            }

                            //sepete ekle gtag
                            dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                            dataLayer.push({
                                event: "ecom_event",
                                event_category: "ecommerce",
                                event_action: "add_to_cart",
                                ecommerce: {
                                    items: [{
                                        item_id: AddToCartId, //Type: String
                                        item_group_id: ProductCode, //Type: String
                                        item_name: ProductName, //Type: String
                                        currency: "TRY", //Type: String
                                        discount: parseFloat(discountRate), //Type: Float
                                        index: parseInt(ListPosition), //Type: Integer, Desciption: Position in the list
                                        item_brand: "BSL", //Type: String
                                        item_category: catName1, //Type: String, Description: Main category of the product
                                        item_category2: catName2, //Type: String, Description: Type of the product
                                        item_list_id: CatID, //Type: String
                                        item_list_name: catName1, //Type: String
                                        item_variant: null, //Type: String, Description: Size
                                        item_size: (dt.Deger8), //Type: String
                                        item_color: ColorName, //Type: String
                                        price: parseFloat(ProductAmount), //Type: Float
                                        quantity: 1, //Type: Integer
                                        stock: parseInt(dt.Deger1)
                                    }]
                                }
                            });

                        }

                        thisPrd.find(".AddToCartArea").append("<div class='basket-message'>Ürün başarı ile sepetinize eklenmiştir.</div>");

                        setTimeout(function () {
                            thisPrd.find(".AddToCartArea .basket-message").remove();
                        }, 4000)

                        GetSepetIcerik(function (dt) {
                            setTimeout(function () {
                                $basketButton.closest("div.AddToCartArea").children(".TransformContainer").removeClass("select-size");
                            }, 500);

                            $basketButton.attr("data-sizeid", "0");
                            $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html("");

                            $("#UserAndBasket").html(dt);

                            //if ($(window).width() > 991) {
                            //    toggleBasket();
                            //}
                            //BasketAddMessage();

                            GenerateLocalLoading($basketButton.parents(".Prd"), "hide");
                        });
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
                        GenerateLocalLoading($basketButton.parents(".Prd"), "hide");
                    }
                });
            }
            else if (SizeID === "0" && $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html() === "") {
                var params = "ColorID=" + ColorID + "&ProductID=" + ProductID;
                GetSizeOfColor(params);
            }
        }

        return false;
    });

    $('.ProductListSizeContainer div.ProductListSize:not(.passive)').live("click", function () {
        var $currentColor = $(this);
        var sizeID = $(this).attr("data-size");

        $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", sizeID);
        $currentColor.closest(".ProductListSizeContainer").find(".ProductListSize").removeClass("active");
        $currentColor.addClass("active");
        $currentColor.closest(".Prd").find(".AddToCart").click();
    });

    $(".ProductList .Prd").live({
        mouseleave:
            function () {
                $(this).find(".AddToCartArea .TransformContainer").removeClass("select-size");
                //$(this).find(".AddToCartArea .TransformContainer .button-container .AddToCart").removeClass("passive");
                $(this).find(".AddToCartArea .ProductListSizeContainer").html("");
            }
    });

    $('.ProductListColorContainer div.ProductListColor:not(.passive)').live("click", function () {
        var $currentColor = $(this);

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var item_unique_id = $(this).attr("data-item-unique-id");
        var sizeID = $(this).attr("data-size");
        var params = "ColorID=" + colorID + "&ProductID=" + productID;

        if (typeof sizeID === "undefined") {
            sizeID = 0;

            $detailLinks = $(this).closest(".Prd").find("a");
            $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");
            $currentColor.addClass("active");

            GetImageOfColors(params, item_unique_id, $currentColor);

            $currentColor.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html("");
            $currentColor.closest(".AddToCartArea").find(".TransformContainer").removeClass("select-size");
        }
    });

    $('.ProductList .Prd').live("click", function (e) {
        var ScrollContentID = "LastScrollTop" + $("#PID").val();
        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });
    });

    //if (isMobile(true)) {
    //    if ($("div.row.Products").length > 0) {
    //        var ScrollSize = +70;
    //        var offsetTop = 0;

    //        ScrollSize = 50;
    //        offsetTop = $(".BreadCrumbArea:first").offset().top;

    //        $('html, body').animate({
    //            scrollTop: offsetTop - ScrollSize
    //        }, 500);
    //    }
    //}
    // End Ürünler

    // Renk ve Beden Filteri
    $('#Colors > li, #Sizes > li, #Properties > li, #Cloth > li, #ProductGroup > li').click(function (event) {
        FilterItemSelect($(this));
    });

    // Seçili Filtre Alanını Açıp/Kapatır
    $(".SelectedFilter .SelectedFilterHeader").click(function (event) {
        if ($(window).width() > 767) {
            $(".CategoryLeftBar").removeClass("open");

            //var status = $(".SelectedFilter .SelectedFilterBody").hasClass("closed");
            //var sendEvent = "";

            //if (status == false) {
            //    sendEvent = "Down";
            //}
            //else {
            //    sendEvent = "Up";
            //}

            //if (sendEvent != null && sendEvent != "" && sendEvent != undefined) {
            //    OpenCloseSelectedFilterArea(sendEvent);
            //}
        }

    });

    // Renk filtresi açıldığında küçük ekranlarda filtrenin sığması için
    $(".colorsFilter.toggle-plus").live("click", function () {
        if ($(window).width() > 991 && $(window).height() < 1000)
            $(".CategoryLeftBar").css("height", "89%");
    });

    // Seçili Filtreler Alanındaki Filteri Kaldırma
    $(".SelectedFilterCancelIcon").live("click", function () {
        var selectedVal = $(this).attr("data-value");
        var selectedType = $(this).attr("data-type");

        ClearSelectedFilter(selectedVal, selectedType);
    });

    // Tüm Filtreleri Kaldırır
    $(".AppylArea .ClearAllFilter").live("click", function () {
        ClearAllFilter("true");
    });

    // Tükenenleri Gizle
    //$('#SoldOutOp > li.gr input').click(function (event) {
    //    SoldOutFilter($(this));
    //});

    // Sıralama
    $('#PrdSort > li input').click(function (event) {
        ProductSort($(this));
    });

    // Yeni Açının Çağrılması
    $(document).on("slid.bs.carousel", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        var ImageSrc = $(this).find(".carousel-item.active").find("img").attr("src");
        $nextOrPrevImage = $(this).find(".carousel-item.active").find("img");

        if (ImageSrc != undefined && ImageSrc.indexOf("lazy_back_new.jpg") != -1) {
            $nextOrPrevImage.attr("src", $nextOrPrevImage.attr("data-src"));
        }
    });

    if (window.innerWidth < 991) {
        $(document).on("swiperight", ".ProductList .Prd .PrdImgsBox .carousel", function () {
            $(this).carousel('prev');
        });

        $(document).on("swipeleft", ".ProductList .Prd .PrdImgsBox .carousel", function () {
            $(this).carousel('next');
        });
    }

    else {
        // Yeni Açının Çağrılması GÜNCEL - Hover 2. resim
        $(document).on("mouseenter", ".ProductList .Prd .PrdImgsBox .carousel", function () {
            $(this).carousel('next');
        });

        $(document).on("mouseleave", ".ProductList .Prd .PrdImgsBox .carousel", function () {
            $(this).carousel('prev');
        });
    }

    // Paging İsteği
    //$(".Pages a, #nextPage a").live("click", function () {
    //    var pageNo = $(this).attr("data-pgno");

    //    $.cookie("lastScroll", 0, { path: '/', expires: date });
    //    $.cookie("getLastScrollFirst", 0, { path: '/', expires: date });

    //    if (pageNo != null && pageNo != undefined && pageNo != "") {
    //        getPageByPageNo(pageNo);
    //    }
    //});

    // Ürün'e Tıklandığında Scroll Position Alınır
    $(".ProductList a img:not(.NextPageImg)").live("click", function () {
        var lastScroll = $(window).scrollTop();
        var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

        if (NativeQueryFilter.indexOf("=") != "-1") {
            $.cookie("lastScroll", lastScroll, { path: '/', expires: date });
        }
        else {
            $.cookie("getLastScrollFirst", lastScroll, { path: '/', expires: date });
        }
    });

    // Filtreleme İsteği
    $(".AppylArea .FilterApplyButton").live("click", function () {
        GetPageByFilter();
    });

    // Kategori Açıklama Yazısını Gösterir
    $('.CatShowMore, .CatShowLess').on('click', function (e, index) {
        var Clicked = $(this).attr("class");
        CatDescShowOrHide(Clicked);
    });

    // Filter Search
    $(".SearchInList .SearchFilter").keyup(function () {
        var input, filter, txtValue, li;
        input = $(this).val();
        filter = input.toLocaleLowerCase();
        li = $(this).parents(".First").find(".FilterOption > ul > li");

        li.each(function (index) {
            txtValue = $(this).find("input[type='checkbox']").first().attr("data-rel");

            if (txtValue.toLocaleLowerCase().indexOf(filter) > -1) {
                $(this).css("display", "block");
            } else {
                $(this).css("display", "none");
            }
        });
    });

    $(document).on("click", ".js-cat-follow", function () {

        var button = $(this);
        var ProductID = button.attr("data-pid");
        var ColorID = button.attr("data-cid");

        var temp = $('.AddToCart');
        var productcode = temp.attr('data-productcode');
        var colorcode = temp.attr('data-ColorCode');
        var AddToCartId = productcode + "-R" + colorcode;
        var ProductName = temp.attr('data-productname');
        var ListPositions = temp.attr('data-listposition');

        var CatalogName = $('#PrivateCatalogName').val();

        var CatalogId = temp.attr('data-CatalogId');
        var ColorName = temp.attr('data-colorname');

        var amountData = temp.attr('data-productamount');

        if (amountData) {
            var AmountV2 = temp.attr('data-productamount').replace(',', '.');
        }

        var Quantity = temp.attr('data-quantity');

        var currentUrl = window.location.pathname;

        var catalogList = currentUrl.split('/');

        var catalogNameList = [];

        for (var i = 2; i < catalogList.length; i++) {

            if (catalogList[i] != null && catalogList[i] != undefined && catalogList[i].length > 0) {

                catalogNameList.push(catalogList[i]);

            }
        }

        if (ProductID && ColorID) {
            if (!button.hasClass("activeFavorite")) {
                GenerateLocalLoading(button.parents(".Prd"), "show");

                AddToFavorite(ColorID, ProductID, function (status, msg) {
                    if (status) {

                        if (catalogNameList != null && catalogNameList != undefined && catalogNameList.length > 0) {

                            var catName1 = null;
                            var catName2 = null;
                            var catName3 = null;

                            for (var i = 0; i < catalogNameList.length; i++) {
                                if (i == 0 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                    catName1 = catalogNameList[i];
                                }
                                else if (i == 1 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                    catName2 = catalogNameList[i];
                                }
                                else if (i == 2 && catalogNameList[i] != null && catalogNameList[i] != undefined && catalogNameList[i].length > 0) {
                                    catName3 = catalogNameList[i];
                                }
                            }

                            var PrivateCatName3 = catName3;
                            if (PrivateCatName3 == null) {
                                PrivateCatName3 = catName2;
                            }
                            if (catName2 == null && PrivateCatName3 == null) {
                                PrivateCatName3 = catName1;
                            }
                            if (catName2 == null && PrivateCatName3 == null && catName1 == null) {
                                PrivateCatName3 = null;
                            }

                            //gtag script
                            dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                            dataLayer.push({
                                event: "ecom_event",
                                event_category: "ecommerce",
                                event_action: "add_to_wishlist",
                                ecommerce: {
                                    items: [{
                                        item_id: AddToCartId, //Type: String
                                        item_group_id: productcode, //Type: String
                                        item_name: ProductName, //Type: String
                                        currency: "TRY", //Type: String
                                        discount: null, //Type: Float
                                        index: parseInt(ListPositions), //Type: Integer, Desciption: Position in the list
                                        item_brand: "BSL", //Type: String
                                        item_category: catName1, //Type: String, Description: Main category of the product
                                        item_category2: catName2, //Type: String, Description: Type of the product
                                        item_list_id: CatalogId, //Type: String
                                        item_list_name: PrivateCatName3, //Type: String
                                        item_variant: null, //Type: String, Description: Size
                                        item_size: null, //Type: String
                                        item_color: ColorName, //Type: String
                                        price: parseFloat(AmountV2), //Type: Float
                                        quantity: 1, //Type: Integer
                                        stock: parseInt(Quantity)
                                    }]
                                }
                            });
                        }

                        button.addClass("activeFavorite");
                        button.find(".sorsfont").removeClass("sorsfont-follow").addClass("sorsfont-added-follow");

                        SwalGenerate("success", msg, "İşlem Başarılı", "Kapat");
                    }
                    else
                        SwalGenerate("warning", msg, "İşlem Başarısız", "Kapat");

                    GenerateLocalLoading(button.parents(".Prd"), "hide");
                });
            }
            else {
                GenerateLocalLoading(button.parents(".Prd"), "show");

                removeFavorite(ProductID, function (status) {
                    if (status) {
                        button.removeClass("activeFavorite");
                        button.find(".sorsfont").addClass("sorsfont-follow").removeClass("sorsfont-added-follow");

                        SwalGenerate("success", "Ürün favorilerinizden çıkarılmıştır.", "İşlem Başarılı", "Kapat");
                    }
                    else {
                        SwalGenerate("warning", "Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!", "İşlem Başarısız", "Kapat");
                    }

                    GenerateLocalLoading(button.parents(".Prd"), "hide");
                });
            }
        }
    });
});

// Kategori Açıklama Yazısını Açıp/Kapatır
function CatDescShowOrHide($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "CatShowMore") {
            $(".CatShowMore").hide();
            $('.CatShowLess').show();
            $('.CatSecondPart').show();
            $('.CatShortPart').hide();
        }
        else {
            $(".CatShowLess").hide();
            $('.CatShowMore').show();
            $('.CatSecondPart').hide();
            $('.CatShortPart').show();
        }
    }
}

// Filteleri seçili yapar
function FilterItemSelect($GroupName) {
    $li = $GroupName;

    if ($li.find("input:checked").length > 0) {

        $li.find("input").removeAttr("checked");
        $li.removeClass("selected");
        $li.find("label").removeClass("c_on");
    }
    else {
        $li.find("input").attr("checked", "checked");
        $li.addClass("selected");
        $li.find("label").addClass("c_on");
    }

    $li.find("input").trigger("change");
}

// Seçili Filtre Alanını Açıp/Kapatan Fonksiyon (Up/Down değeri alır)
function OpenCloseSelectedFilterArea($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "Up") {
            $(".SelectedFilterBody").slideDown("slow");
            $(".SelectedFilter .SelectedFilterBody").removeClass("closed");
            $(".SelectedFilter").show();
        }
        else if ($event == "Down") {
            $(".SelectedFilterBody").slideUp("slow");
            $(".SelectedFilter .SelectedFilterBody").addClass("closed");
            $(".SelectedFilter").hide();
        }
    }
}

// Tükenenleri Gizle Seçeneğini Kontrol Eden Fonksiyon
function SoldOutFilter($soldOut) {

    //$li = $soldOut.parent();

    //if ($li.find("input").val() == "0") {
    //    $li.find("label").addClass("checked2");
    //    $li.find("input").val("1");
    //    GetPageByFilter();
    //}
    //else {
    //    $li.find("label").removeClass("checked2");
    //    $li.find("input").val("0");

    //    var currentPage = $(".Pages a.selected").attr("data-pgno");
    //    getPageByPageNo(currentPage);
    //}

}

// Sıralama Seçeneğini Kontrol Eden Fonksiyon
function ProductSort($selectedSort) {

    $li = $selectedSort.parent();

    // Tüm seçenekleri kapatır
    $("#PrdSort input").removeAttr("checked");
    $("#PrdSort label").removeClass("checked");
    $("#PrdSort label").removeClass("c_on");

    // Kullanıcının istediği seçeneği seçili yapar
    $li.find("label").addClass("checked");
    $li.find("label").addClass("c_on");
    $(".CategoryLeftBar").removeClass("open");
    $(".ProductColumn").removeClass("open");
    $("body").removeClass("overflow-hidden")

    // Sıralama ekranını kapatır
    //$(".fLinkSortNo").removeClass("toggle-minus");
    //$("#PrdSort").parent().hide();

    //$(".fLinkSortNo").html("<i class='sorsfont sorsfont-dropdown-down'></i>" + $li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir

    var currentPage = "1";

    if ($("#IsInfinity").val() == "False") {
        currentPage = $(".Pages a.selected").attr("data-pgno"); // Kullanıcının bulunduğu sayfa alınır
    }

    if (IsSearch()) {
        currentPage = "1";
    }

    getPageByPageNo(currentPage);
}

function ShowOrHideBackDrop($event) {

    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "show") {
            $(".backdrop").addClass("ShowBackdrop");
            $(".LoadingGif").show();
        }
        else if ($event == "hide") {
            $(".backdrop").removeClass("ShowBackdrop");
            $(".LoadingGif").hide();
        }
    }

}

// Paging İçin Ajax
function getPageByPageNo(pageNo) {
    var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri

    $('html, body').animate({ // Listenin başına döndürür
        scrollTop: 0
    }, 0);

    var params = GenerateParams("paging", pageNo); // Sayfalama için istek parametresi üretir

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList",
        data: params,
        cache: false,
        beforeSend: function () {
            ShowOrHideBackDrop("show"); // Loader gösterilir
        },
        complete: function () {
            ShowOrHideBackDrop("hide"); // Loader kapatılır
        },
        success: function (data) {
            //var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            //var newURL = location.pathname + "?" + params;

            //if (ios == false) {
            //    window.history.replaceState({}, "", newURL); // Sayfa URL'inin değişmesini sağlar
            //}
            //else {
            //    history.pushState({}, "", newURL);
            //}

            window.history.replaceState({}, "", location.pathname + "?" + params); // Sayfa URL'inin değişmesini sağlar

            var IsInfinity = $("#IsInfinity").val();

            if (IsInfinity == "True") {
                $container.infiniteScroll('destroy');
                $(".Products").html(data);

                SetGridByCookie();

                InfinityScroll();
                LazyLoad();
            }
            else {
                $(".Products").html(data);
                LazyLoad();

                SetGridByCookie();

                if ($(window).width() < 991) {
                    $(".mobilFilterArea").removeClass("open");
                    $(".backdrop").removeClass("rightMenu");
                }
                else {
                    GetSelectedFilter(); // Seçimleriniz Alanına Seçili Filtreleri Ekler
                }
            }


            if ($(".SuggestedProductsContainer").length > 0) {
                SetLastVisitedProductsStorage();
            }

            SetUrl();
            StartProductVideoFoProductList();
        }
    });
}

// Filter İçin Ajax
function GetPageByFilter() {
    ShowOrHideBackDrop("show"); // Loader gösterilir

    var newScrollPosition = $(".Products").position(); // Filtreleme&Sayfalama işleminden sonra scroll'un gideceği position değeri

    $('html, body').animate({ // Listenin başına döndürür
        scrollTop: 0 // newScrollPosition.top
    }, 0);

    var params = GenerateParams("filter"); // Filtreleme için istek parametresi üretir

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetProductList",
        data: params,
        cache: false,
        success: function (data) {

            ShowOrHideBackDrop("hide"); // Loader kapatılır
            window.history.replaceState({}, "", location.pathname + "?" + params); // Sayfa URL'inin değişmesini sağlar

            var IsInfinity = $("#IsInfinity").val();

            if (IsInfinity == "True") {
                $container.infiniteScroll('destroy');
                $(".Products").html(data);
                InfinityScroll();
                LazyLoad();
            }
            else {
                $(".Products").html(data);
                LazyLoad();
            }

            if ($(".SuggestedProductsContainer").length > 0) {
                SetLastVisitedProductsStorage();
            }

            SetGridByCookie();

            if ($(window).width() < 767) {
                $(".mobilFilterArea").removeClass("open");
                $(".backdrop").removeClass("rightMenu");
            }
            else {
                GetSelectedFilter(); // Seçimleriniz Alanına Seçili Filtreleri Ekler
            }

            SetUrl();

            var TotalCount = $("#ProductCountTotal").text();

            $(".TotalProductCount").text("(" + TotalCount + " Ürün)");

            StartProductVideoFoProductList();
        },
        error: function () {
            ShowOrHideBackDrop("hide"); // Loader kapatılır
        }
    });
}

// Filtreleme Ve Sayfalama İsteklerinde Parametre Oluşturur
function GenerateParams($action, $pageNo) {
    var params = "";
    var CatalogPart = "";
    if ($action != null && $action != "" && $action != undefined) {

        // Sayfa Numarasını Ayarlar
        if ($action == "paging") {
            params = "p=" + $pageNo;
        }
        else if ($action == "filter") {
            params = "p=1";
        }
        // Sayfa Numarasını Ayarlar

        if (!IsSearch()) {
            CatalogPart = "&ct=" + $("#PID").val(); // Catalog ID'sini alır

            if ($("#ProductGroup input[type='checkbox']:checked").length > 0) {
                CatalogPart = "&ct=";

                $("#ProductGroup input[type='checkbox']:checked").each(function (index) {
                    CatalogPart += $(this).val() + ",";
                });

                CatalogPart = CatalogPart.substring(0, CatalogPart.length - 1);
            }
        }
        else {
            params += "&sr=" + $("#PID").val(); // Search değerini alır
        }

        params += CatalogPart;

        // Cookide kayıtlı grid değeri varsa onu ekler
        cookieGrid = $.cookie("BSLgridCookie");
        if (cookieGrid != null && cookieGrid != "" && cookieGrid != undefined) {
            params += "&g=" + cookieGrid;
        }
        // Cookide kayıtlı grid değeri varsa onu ekler

        // Tükenenleri Gizle Seçeneğini Kontrol Eder
        var SoldOut = $("#SoldOutOp li input").val();
        if (SoldOut == "1") {
            params += "&so=" + SoldOut;
        }
        // Tükenenleri Gizle Seçeneğini Kontrol Eder

        // Sıralama Seçeneğini Kontrol Eder
        $PrcSort = $("#PrdSort > li > label.checked");
        var SelectedSortID = $PrcSort.parent().children("input").val();
        if (SelectedSortID != null && SelectedSortID != "" && SelectedSortID != undefined) {
            params += "&o=" + SelectedSortID;
        }
        // Sıralama Seçeneğini Kontrol Eder

        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedColors = "";
        $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedColors += $(this).children("input").val() + ",";
        });

        if (SelectedColors != "" && SelectedColors != null && SelectedColors != undefined) {
            params += "&c=" + SelectedColors.substring(0, SelectedColors.length - 1); // Substring ile sondaki virgül silinir
        }
        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSizes = "";
        $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedSizes += $(this).children("input").val() + ",";
        });

        if (SelectedSizes != "" && SelectedSizes != null && SelectedSizes != undefined) {
            params += "&s=" + SelectedSizes.substring(0, SelectedSizes.length - 1); // Substring ile sondaki virgül silinir
        }
        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedProperties = "";
        $("#Properties li.selected").each(function (index) { // Seçili özellikleri döndürür
            SelectedProperties += $(this).children("input").val() + ",";
        });

        if (SelectedProperties != "" && SelectedProperties != null && SelectedProperties != undefined) {
            params += "&prp=" + SelectedProperties.substring(0, SelectedProperties.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Kumaş Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedCloth = "";
        $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedCloth += $(this).children("input").val() + ",";
        });

        if (SelectedCloth != "" && SelectedCloth != null && SelectedCloth != undefined) {
            params += "&clh=" + SelectedCloth.substring(0, SelectedCloth.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
        if ($("#SliderValue").val() != null && $("#SliderValue").val() != "" && $("#SliderValue").val() != undefined && $("#SliderValue").val() != "0-2000") {
            params += "&prc=" + $("#SliderValue").val();
        }
        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler

    }

    return params;
}

function SetUrl() {
    var sr = $("#PID").val();
    var CurrentPageTitle = $("#PageTitle").val();
    var CurrentH1Title = $("#PageH1").val();
    var CustomFiltersTitle = "";
    var CustomFilterURL = "";
    var TotalCount = $("#ProductCountTotal").text();
    var i = 0;

    $("#Properties li.selected").each(function (index) { // Seçili özellikleri döndürür
        if (i == 0) {
            CustomFiltersTitle += $(this).find(".checkText").text();
            CustomFilterURL += $(this).find("input").attr("data-url");
        }
        else {
            CustomFiltersTitle += ", " + $(this).find(".checkText").text();
            CustomFilterURL += "-" + $(this).find("input").attr("data-url");
        }
        i++;
    });

    $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür
        if (i == 0) {
            CustomFiltersTitle += $(this).find(".checkText").text();
            CustomFilterURL += $(this).find("input").attr("data-url");
        }
        else {
            CustomFiltersTitle += ", " + $(this).find(".checkText").text();
            CustomFilterURL += "-" + $(this).find("input").attr("data-url");
        }
        i++;
    });

    if (sr != null && sr != undefined && sr != "") {

        //$("h1").html('"' + sr + '" araması için ' + '"' + TotalCount + '" adet ürün bulundu.');
    }
    else {
        $("h1").html(CustomFiltersTitle + " " + CurrentH1Title);
    }

    CustomFiltersTitle = CustomFiltersTitle + " " + CurrentPageTitle;
    $(document).prop('title', CustomFiltersTitle);

    var Hash = window.location.href.slice(window.location.href.indexOf('?') + 1);
    var CurrentPath = $("#ParentCatalogURL").val();
    var SmallLangCode = $("#SmallLangCode").val();

    if (CustomFilterURL != "") {
        CustomFilterURL += "--";
    }

    if (CurrentPath == "" || CurrentPath == null || CurrentPath == undefined) {
        CurrentPath = "p/NewCat/NewSearch";
    }

    window.history.pushState('', '', "/" + SmallLangCode + "/" + CurrentPath.replace("{ReplacePlace}", CustomFilterURL) + "?" + Hash);
}

// Sayfalama İşleminden Önce URL History Oluşturur
function GenerateUrlHistoy() {

    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // Var olan QueryString'i okur
    var PathName = window.location.pathname; // Bulunan kataloğun url'ini alır
    var CurrentURL = "";

    if (getQueryFilter.indexOf("=") != "-1") {
        CurrentURL = PathName + "?" + getQueryFilter;
    }
    else {
        CurrentURL = PathName;
    }

    if (CurrentURL != null && CurrentURL != "" && CurrentURL != undefined) {
        window.history.pushState('', '', CurrentURL);
    }
}

// Sayfalar Arası Gezerken Browser Back/Prev Butonlarını Kontrol Eder
function BrowserBackAndPrevButtonControl() {
    //$(window).on('popstate', function (event) {

    //    var vars = [], hash;
    //    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    //    var IsCatalogFirsPage = true;

    //    for (var i = 0; i < getQueryFilter.length; i++) {
    //        hash = getQueryFilter[i].split('=');
    //        vars.push(hash[0]);
    //        vars[hash[0]] = hash[1];

    //        if (hash[0] == "p") {
    //            getPageByPageNo(hash[1], "true");
    //            IsCatalogFirsPage = false;
    //        }
    //    }

    //    if (IsCatalogFirsPage == true) {
    //        getPageByPageNo(1, "true");
    //    }

    //});
}

// Seçili Filtreleri Ekler
function GetSelectedFilter() {

    $SelectedFilterBody = $(".SelectedFilter .SelectedFilterBody ul");
    $SelectedFilterBody.html("");

    var Color = "Renk";
    var Size = "Beden";
    var Price = "Fiyat";
    var Propertie = "Özellik";
    var Cloth = "Kumaş";
    var ProductGroup = "Ürün Grubu";

    if ($("#SmallLangCode").val() == "en") {
        Color = "Color";
        Size = "Size";
        Price = "Price";
        Propertie = "Propertie";
        Cloth = "Cloth";
        ProductGroup = "Product Group";
    }
    else if ($("#SmallLangCode").val() == "fr") {
        Color = "Couleur";
        Size = "Taille";
        Price = "Prix";
        Propertie = "Propertie";
        Cloth = "Cloth";
    }

    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#ProductGroup li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterTitle'>" + ProductGroup + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='ProductGroup'><img src='/Images/BSL/del.png' /></span>";
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterTitle'>" + Color + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='color'><img src='/Images/BSL/del.png' /></span>";
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterTitle'>" + Size + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='size'><img src='/Images/BSL/del.png' /></span>";
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Properties li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterTitle'>" + Propertie + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='properties'><img src='/Images/BSL/del.png' /></span>";
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Özellik Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür

        $li = "<li>";
        $li += "<span class='SelectedFilterTitle'>" + Cloth + ":</span> " + $(this).children("input").attr("data-rel");
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='cloth'><img src='/Images/BSL/del.png' /></span>";
        $li += "</li>";

        $SelectedFilterBody.append($li);
    });
    // Kumaş Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $PriceSlide = $("#SliderValue").val();
    if ($PriceSlide != "0-2000" && $PriceSlide != null && $PriceSlide != "" && $PriceSlide != undefined) {
        $li = "<li>";
        $li += "<span class='SelectedFilterTitle'>" + Price + ":</span> " + $PriceSlide;
        $li += "<span class='SelectedFilterCancelIcon' data-value='" + $PriceSlide + "' data-type='price'><img src='/Images/BSL/del.png' /></span>";
        $li += "</li>";

        $SelectedFilterBody.append($li);
    }
    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler 

    if ($SelectedFilterBody.find("li").length > 0) {
        OpenCloseSelectedFilterArea("Up"); // Filtre seçiliyse Seçili Filtreler alanını açar

        // Tüm filtreleri temizleme seçeneği
        var ClearText = "Seçimleri Temizle";
        if ($("#SmallLangCode") == "en") {
            ClearText = "Clear Selections";
        }
        else if ($("#SmallLangCode") == "fr") {
            ClearText = "Effacer Les Sélections";
        }

        //$li = "<li><span class='ClearAllFilter'>" + ClearText + "</span></li>";
        //$SelectedFilterBody.append($li);
        // Tüm filtreleri temizleme seçeneği ( Filtrele seçeneğinin yanına buton olarak taşındı )
    }
    else {
        OpenCloseSelectedFilterArea("Down"); // Filtre seçili değilse Seçili Filtreler alanını kapatır
    }
}

// Seçili Filtreleri Kaldıran Fonksiyon
function ClearSelectedFilter($selectedVal, $selectedType) {
    var selectedVal = $selectedVal;
    var selectedType = $selectedType;

    if (selectedVal != null && selectedVal != "" && selectedVal != undefined && selectedType != null && selectedType != "" && selectedType != undefined) {
        if (selectedType == "color") { // Filtre alanındaki seçili Color fitresini kaldırır
            $("#Colors li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Colors li label[for='c-" + selectedVal + "']").removeClass("c_on");
            $("#Colors li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "ProductGroup") { // Filtre alanındaki seçili Ürün Grubu fitresini kaldırır
            $("#ProductGroup li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#ProductGroup li label[for='ct-" + selectedVal + "']").removeClass("c_on");
            $("#ProductGroup li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "size") { // Filtre alanındaki seçili Size fitresini kaldırır
            $("#Sizes li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Sizes li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Sizes li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "properties") { // Filtre alanındaki seçili Özellik fitresini kaldırır
            $("#Properties li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Properties li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Properties li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "properties") { // Filtre alanındaki seçili Kumaş fitresini kaldırır
            $("#Cloth li input[value='" + selectedVal + "']").removeAttr("checked");
            $("#Cloth li label[for='s-" + selectedVal + "']").removeClass("c_on");
            $("#Cloth li input[value='" + selectedVal + "']").parent("li").removeClass("selected");
            GetPageByFilter();
        }
        else if (selectedType == "price") { // Filtre alanındaki seçili Price fitresini kaldırır
            $("#MinPrice").val("0");
            $("#MaxPrice").val("2000");
            $("#SliderValue").val("0-2000");
            var slider = document.getElementById('PriceSlider');
            slider.noUiSlider.reset();
            GetPageByFilter();
        }
    }
}

// Tüm Filtreleri Kaldıran Fonksiyon
function ClearAllFilter($IsReload) {

    // Color filtrelerini kaldırır
    $("#Colors li input").removeAttr("checked");
    $("#Colors li label").removeClass("c_on");
    $("#Colors li input").parent("li").removeClass("selected");

    // Ürün Grubu filtrelerini kaldırır
    $("#ProductGroup li input").removeAttr("checked");
    $("#ProductGroup li label").removeClass("c_on");
    $("#ProductGroup li input").parent("li").removeClass("selected");

    // Size filtrelerini kaldırır
    $("#Sizes li input").removeAttr("checked");
    $("#Sizes li label").removeClass("c_on");
    $("#Sizes li input").parent("li").removeClass("selected");

    // Özellik filtrelerini kaldırır
    $("#Properties li input").removeAttr("checked");
    $("#Properties li label").removeClass("c_on");
    $("#Properties li input").parent("li").removeClass("selected");

    // Kumaş filtrelerini kaldırır
    $("#Cloth li input").removeAttr("checked");
    $("#Cloth li label").removeClass("c_on");
    $("#Cloth li input").parent("li").removeClass("selected");

    // Price filtresini kaldırır
    $("#MinPrice").val("0");
    $("#MaxPrice").val("2000");
    $("#SliderValue").val("0-2000");
    var slider = $('#PriceSlider');

    //if ($('#PriceSlider').length > 0) {
    //    slider.noUiSlider.reset();
    //}

    if ($IsReload == "true") {
        GetPageByFilter(); // Filtreleri temizledikten sonra istek yapar
    }
}

// Mobil Filtre ve Sıralama Alanını Aldığı Değere Göre Açıp/Kapatan Fonksiyon
function MobilSortFilterAreaOpenOrClose($AreaName) {
    if ($AreaName != null && $AreaName != "" && $AreaName != undefined) {

        if ($AreaName == ".MobilSortArea") {
            $($AreaName).slideToggle("normal");
            $(".backdrop").toggleClass("openFilter");
        }
        else {
            $(".MobilSortArea").slideUp("normal", function () {
                $($AreaName).toggleClass("open");
                $(".backdrop").removeClass("openFilter");
                $(".backdrop").toggleClass("rightMenu");
            });
        }
    }
}

// Listelenen ürünlerden videoya sahip olan ürünlerin videolarının yüklenmesi için yapılan işlem
function StartProductVideoFoProductList() {

    $(".PrdContainer .Products .ProductList video:not(.video-started)").each(function () {
        var thisProduct = $(this).closest(".PrdImgsBox").parent();
        var thisIdValue = $(this).attr("id");
        var videoPath = $(this).attr("data-src");
        var thisStart = false;
        var thisVideo = $(this);

        if (videojs.players && videojs.players[thisIdValue]) {
            videojs.players[thisIdValue].dispose();
        }

        var player = videojs(thisIdValue, {
            sources: [{
                src: videoPath,
                type: 'video/mp4'
            }],
            muted: true,
            autoplay: true,
            loop: true,
            preload: "none"
        });

        $(window).scroll(function () {
            if (!thisStart &&
                ($(window).scrollTop() + $(window).height()) > (thisProduct.offset().top - 100)
            ) {
                player.play();
                thisStart = true;
            }
            //else if (thisStart &&
            //    (thisProduct.offset().top + $(window).height() < $(window).scrollTop() )
            //) {
            //    console.log("durdur");
            //    player.pause();
            //    thisStart = false;
            //}                
        });

        player.on("loadeddata", function () {
            //thisProduct.find(".PImage").remove();
            thisProduct.find("video").addClass('video-started');
        });

        //player.on("ended", function () {
        //    thisProduct.on("mouseover", function () {
        //        player.play();
        //    });

        //    thisProduct.on("mouseleave", function () {
        //        player.pause();
        //    });
        //});        
    });
}

// Favorilerin kontrolü
function IsFollowCategory() {

    if ($(".PrdItemBox .js-cat-follow").length <= 0) {
        return;
    }

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/NewCat/IsFollowAll",
        dataType: 'json',
        async: true,
        success: function (dt) {
            updateList(dt);
        },
    });

    var updateList = function (dt) {
        for (var i in dt) {
            var item = dt[i];

            var followlar = $(".PrdItemBox .js-cat-follow").filter(function (index) {
                return $(this).attr("data-pid") == item["ProductID"] && $(this).attr("data-cid") == item["ColorID"];
            });

            if (followlar.length > 0) {
                var followItem = $(followlar[0]);
                followItem.addClass("activeFavorite");

                if (followItem.find(".activeFavorite")) {
                    followItem.find(".sorsfont").removeClass("sorsfont-follow");
                    followItem.find(".sorsfont").addClass("sorsfont-added-follow");
                }
            }
        }
    };
}
